document.addEventListener('DOMContentLoaded', function () {
  $(document).on("click", ".product-grid-swatcher.input-color__swatch", function(){
    changeDisplayingImage($(this))
  });
  
  $(document).on("click", ".product-size.input-size", function(){
    changeSelectedVariant($(this).get( 0 ))
  });
    
  function changeDisplayingImage(buttonQuery) {
    const button = buttonQuery.get( 0 )
    changeSelectedVariant(button);
    const images = button.parentNode.closest('div.product-card-container').querySelectorAll('img.grid-view-item__image:not(.hover-img)');
    const currentImg = Array.from(images).find(({ classList }) => !classList.contains('hide'));
    const imgLabel = button.parentNode.closest('div.product-card-container').querySelectorAll('div.variant-title')[0];
    const buttonImg = buttonQuery.closest('li').find("img[id='"+button.value+"']")[0];
    if (currentImg.id !== buttonImg.id) {
      buttonImg.classList.remove("hide");
      currentImg.classList.add("hide");
      imgLabel.innerText = button.value
    }
  }

  function changeSelectedVariant(button) {
    const form = button.parentNode.closest('form');
    const hiddenInput = form.querySelectorAll('input[name="id"]')[0];
    hiddenInput.value = button.attributes["data-id"].value;

    const addToCart = form.querySelector('.btn-add');
    const available = button.getAttribute('data-available') === 'true';
    if (addToCart) {
      addToCart.disabled = !available;
      addToCart.value = available ? 'Add to bag' : 'Sold Out';
    }
  }
});